import { useLocation } from "react-router-dom";
import { T } from "./i18n";
import { R } from "./routes";

export function langFromPath(path) {
  if (path.startsWith("/de/") || path === "/de") return "de";
  if (path.startsWith("/en/") || path === "/en") return "en";
  return "es";
}

export function useLang() {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  return { lang, t: T[lang], r: (g) => R[g]?.[lang] || "/" };
}

export const LOCALE = { es: "es-ES", en: "en-GB", de: "de-DE" };

export function fmtDate(iso, lang) {
  try { return new Date(iso).toLocaleDateString(LOCALE[lang], { day: "numeric", month: "long", year: "numeric" }); } catch { return ""; }
}
